import { Routes, Route } from "react-router-dom";

import SmsTemplateListScreen from "screens/App/CRM/SmsTemplate/SmsTemplateListScreen";
import SmsTemplateDetailScreen from "screens/App/CRM/SmsTemplate/SmsTemplateDetailScreen";
import SmsTemplateEditScreen from "screens/App/CRM/SmsTemplate/SmsTemplateEditScreen";
import SmsTemplateCreateScreen from "screens/App/CRM/SmsTemplate/SmsTemplateCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const SmsTemplateRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<SmsTemplateListScreen />} />
      <Route path="create" element={<SmsTemplateCreateScreen />} />
      <Route path=":id/detail" element={<SmsTemplateDetailScreen />} />
      <Route path=":id/edit" element={<SmsTemplateEditScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default SmsTemplateRouter;